import React, { CSSProperties, FunctionComponent, HTMLAttributes } from 'react'
import styles from './Badge.module.sass'
import clsx from 'clsx'
import Tooltip from '../Tooltip'
import { Colors } from '../../../styles'

interface Props extends HTMLAttributes<HTMLDivElement> {
    badgeClassName?: string,
    badge?: string | number | boolean,
    padding?: number,
    top?: number,
    title?: string,
    color?: string,
}

const Badge: FunctionComponent<Props> = (
    {
        className,
        badge,
        badgeClassName,
        padding,
        top,
        title,
        color,
        children,
        ...restProps
    }
) => <div
    {...restProps}
    className={clsx(className, styles.badge)}
>
    {children}
    {
        badge ? <Tooltip
            className={clsx(badgeClassName, styles.text, { [styles.active]: !!title })}
            title={title}
            styles={{
                position: 'absolute',
                '--top': `${(padding ?? 0) - (top ?? 0)}px`,
                '--right': `${(padding ?? 0)}px`,
                background: color ?? Colors.orange
            } as CSSProperties}
        >
            <span>{badge}</span>
        </Tooltip> : ''
    }
</div>

export default Badge